import { QueryClient } from "@tanstack/vue-query";

/**
 * The single `QueryClient` instance for the app, created explicitly (instead of letting
 * `VueQueryPlugin` build its own internally) so it can also be imported by code that isn't a Vue
 * component and can't call `useQueryClient()` — router navigation guards (`src/pages/index.ts`) and
 * Pinia store actions (`src/store/events.js`) both need to read/warm query-cache data this way.
 * Wired into the app via `app.use(VueQueryPlugin, { queryClient, ... })` in `src/main.js`.
 */
export const queryClient = new QueryClient();
